import React, {useState, useEffect} from 'react';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import EditSong from './EditSong';
import SongInfo from './SongInfo';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import LoadingOverlay from 'react-loading-overlay-ts';
import { useCookies } from 'react-cookie';

const SongList = () => {
    const [songs, setSongs] = useState([]);
    const [showEditor, setShowEditor] = useState(false);
    const [currentSong, setCurrentSong] = useState();
    const [loading, setLoading] = useState(true);
    const [songToDelete, setSongToDelete] = useState();
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [cookies] = useCookies(['gaia-login']);
    const [savePending, setSavePending] = useState(false);

    useEffect(() => {
        if (savePending) {
            saveSongs();
            setSavePending(false);
        }
    }, [songs])

    useEffect(() => {
        getSongList();
    }, []);

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
      
        return result;
    };

    const removeSong = () => {
        var copy = Array.from(songs);
        if (songToDelete < copy.length &&  songToDelete > -1) {
            console.log("reomoving song " + songToDelete);
            copy.splice(songToDelete, 1);
            setSongToDelete(undefined);
            setSavePending(true);
            setSongs(copy);
            setShowConfirmDelete(false);
        } else {
            setShowConfirmDelete(false);
        }
    }

    const onDragEnd = (result) => {
        console.log(result);
        const reordered = reorder(songs, result.source.index, result.destination.index);
        console.log(reordered);
        setSongs(reordered);
    }

    const getSongList = () => {
        setLoading(true);
        fetch('https://europe-west1-voice-of-gaia.cloudfunctions.net/get-songs-new?includePending=true')
        .then(response => response.json())
        .then((result) => {
            setSongs(result.songs);
            setLoading(false);
        });
    }

    const saveSongs = () => {
        setLoading(true);
        const options = {
            headers: {
                'Authorization': 'Basic ' + btoa(cookies["gaia-login"]),
                'Content-type': 'application/json'
            },
            method: 'POST',
            body: JSON.stringify(songs),
        };
        fetch("https://europe-west1-voice-of-gaia.cloudfunctions.net/update-songs", options).then(() => {
            getSongList();
        })
    };

    const openSongEditor = (song) => {
        console.log("Current song " + currentSong);
        setCurrentSong(song);
        setShowEditor(true);
    }

    const openDeleteConfirm = (index) => {
        setSongToDelete(index);
        setShowConfirmDelete(true);
    }

    return (
        <LoadingOverlay
           active={loading}
            spinner
            text='Loading...'
            >
        <DragDropContext onDragEnd={onDragEnd}>
            <EditSong show={showEditor} song={currentSong} setShow={setShowEditor} callback={getSongList} />
            <Modal show={showConfirmDelete}>
              <Modal.Header>
                <Modal.Title>Confirm delete</Modal.Title>
              </Modal.Header>
            
              { typeof songToDelete !== 'undefined'  && (
              <>
              <Modal.Body>
                <p>Are you sure you want to delete {songs[songToDelete].artist} - {songs[songToDelete].title}?</p>
              </Modal.Body>
            
              <Modal.Footer>
                <Button variant="secondary" onClick={() => { setSongToDelete(); setShowConfirmDelete(false)}}>Cancel</Button>
                <Button variant="primary" onClick={removeSong}>Delete</Button>
              </Modal.Footer>
              </>
              ) }
            </Modal>
            <Droppable droppableId="songlist" >
            {provided => (
                <div ref={provided.innerRef} {...provided.droppableProps} id="songlist">
                    <Button variant="primary" onClick={saveSongs} className="m-3">Save</Button> 
                    <Button variant="primary" onClick={getSongList} className="m-3">Reload list</Button><br/>
                    { songs.map( (song, index) => ( 
                        <SongInfo song={song} index={index} key={song.id} editSong={openSongEditor} deleteSong={openDeleteConfirm} />
                    ))
                }
                {provided.placeholder}
                </div>
            )}
            </Droppable>
        </DragDropContext>
        </LoadingOverlay>
    )
}

export default SongList
